import { Roles } from "@/models/user/roles";
import { PartialNetSuiteCustomer, PriceLevel } from "@/models/netsuite/netsuite";
import { SSOImpersonation } from "@/services/auth_service";
import { GlobalState } from "./types";

export const setLoading = (state: GlobalState, value: boolean) => {
  state.isLoading = value;
};

export const setLoggedIn = (state: GlobalState, value: boolean) => {
  state.isLoggedIn = value;
};

export const setRole = (state: GlobalState, value: Roles | null) => {
  state.userRole = value;
};

export const setMobile = (state: GlobalState, value: boolean) => {
  state.isMobile = value;
};

export const setTablet = (state: GlobalState, value: boolean) => {
  state.isTablet = value;
};

export const setMultiplier = (state: GlobalState, value: PriceLevel | null) => {
  state.multiplier = value;
};

/**
 * Price levels arrive in whatever order the SuiteQL query returned them. Sort
 * them by NetSuite internal id ascending here — the single choke point every
 * consumer reads through — so the multiplier dropdown and any other list is
 * stable regardless of the API's ordering. Sorted on a copy: `sort` mutates in
 * place, and the caller's array (the raw axios response) shouldn't be reordered
 * out from under it.
 */
export const setPriceLevels = (state: GlobalState, value: PriceLevel[]) => {
  state.priceLevels = [...(value ?? [])].sort((a, b) => a.id - b.id);
};

export const setCustomers = (state: GlobalState, value: PartialNetSuiteCustomer[]) => {
  state.customers = value;
};

export const setAuthToken = (state: GlobalState, value: string | null) => {
  state.authToken = value;
};

export const setImpersonation = (state: GlobalState, value: SSOImpersonation | null) => {
  state.impersonation = value;
};
